import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShoppingGuide from "../pages/shopping-guide/page";
import SeoArticleDetail from "../pages/seo-article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gtbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/shopping-guide/:slug",
    element: <SeoArticleDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;